export const buttonDefaultProps = {
    size: 'medium',
    variant: 'primary',
    fullWidth: false,
    isLoading: false,
};
